import React from 'react';
import PropTypes from 'prop-types';
import TextareaAutosize from 'react-autosize-textarea';

function ProjectInvitationCustomTextbox({
  consultantFirstName, updateParentMessage, customMessage,
}) {
  return (
    <div className="form-group question custom-message italicized-placeholder">
      <div className="mb-8">
        <label htmlFor="custom-message">
          <h4 className="regular-spacing">
            {`Message to ${consultantFirstName} (Optional):`}
          </h4>
        </label>
      </div>
      <TextareaAutosize
        type="text"
        className="form-control form-control--light"
        name="consultant-custom-message"
        id="consultant-custom-message"
        rows={5}
        placeholder={`Hi ${consultantFirstName},\nI’d like to invite you to take a look at the project I have just posted. Please submit a proposal if you’re interested.`}
        onChange={(e) => updateParentMessage(e.target.value)}
        value={customMessage}
      />
    </div>
  );
}

ProjectInvitationCustomTextbox.propTypes = {
  consultantFirstName: PropTypes.string.isRequired,
  updateParentMessage: PropTypes.func,
  customMessage: PropTypes.string.isRequired,
};

ProjectInvitationCustomTextbox.defaultProps = {
  updateParentMessage: () => {},
};

export default ProjectInvitationCustomTextbox;
